import { Col } from "reactstrap";
import { AdditiveRadiu } from "../../../../Constant";
import { RADIUS_DATA } from "../../../../Data/UiKit/HelperClasses";
import { H4 } from "../../../../AbstractElements";

export const AdditiveRadius = () => {
  return (
    <Col xl="4" sm="12">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{AdditiveRadiu}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-radius radius-wrapper rounded"></div>.rounded
        </div>
        {RADIUS_DATA.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-radius radius-wrapper ${item}`}></div>.{item}
          </div>
        ))}
      </div>
    </Col>
  );
};
